import { Group, Tooltip } from '@mantine/core'
import { cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { IntegrationType, PipelineSource } from '@/types/vlm'
import { INTEGRATION_CONFIG, getIntegrationsForType } from './vlmPipelineConfig'

type PipelineOutputListProps = {
  source: PipelineSource
  enableCloudResults: boolean
}

export const PipelineOutputList = ({
  source,
  enableCloudResults
}: PipelineOutputListProps) => {
  const integrations = getIntegrationsForType(source.type).filter(
    (type: IntegrationType) => {
      if (type === 'cloud_vlm_results') return enableCloudResults
      // Writing the description back onto the originating application event is
      // opt-in, and only VisionPlatform sources have one.
      if (type === 'cloud_event_enrichment') {
        return source.type === 'visionplatform' && source.upload_descriptions
      }
      return true
    }
  )

  return (
    <Group gap={8} wrap="nowrap" align="center">
      {integrations.map((type) => {
        const { icon, labelId } = INTEGRATION_CONFIG[type]

        return (
          <Tooltip key={type} label={<FormattedMessage id={labelId} />}>
            <span style={{ display: 'inline-flex' }}>
              {cloneElement(icon, { size: 16 })}
            </span>
          </Tooltip>
        )
      })}
    </Group>
  )
}
